/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { FragmentsDeliveryGetStationConfigAllStationsConfigsQueryResponse, FragmentsDeliveryGetStationConfigAllStationsConfigs401, FragmentsDeliveryGetStationConfigAllStationsConfigs403 } from "../models/FragmentsDeliveryGetStationConfigAllStationsConfigs";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { fragmentsDeliveryGetStationConfigAllStationsConfigs } from "../axios/fragmentsDeliveryGetStationConfigAllStationsConfigs";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const fragmentsDeliveryGetStationConfigAllStationsConfigsQueryKey = () => ["api-v2", { url: '/fragments-delivery/v1/station-config/all' }] as const

export type FragmentsDeliveryGetStationConfigAllStationsConfigsQueryKey = ReturnType<typeof fragmentsDeliveryGetStationConfigAllStationsConfigsQueryKey>

export function fragmentsDeliveryGetStationConfigAllStationsConfigsQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = fragmentsDeliveryGetStationConfigAllStationsConfigsQueryKey()
        return queryOptions<FragmentsDeliveryGetStationConfigAllStationsConfigsQueryResponse, ResponseErrorConfig<FragmentsDeliveryGetStationConfigAllStationsConfigs401 | FragmentsDeliveryGetStationConfigAllStationsConfigs403>, FragmentsDeliveryGetStationConfigAllStationsConfigsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return fragmentsDeliveryGetStationConfigAllStationsConfigs({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get all Station configs for a client (client access)
 * {@link /fragments-delivery/v1/station-config/all}
 */
export function useFragmentsDeliveryGetStationConfigAllStationsConfigs<TData = FragmentsDeliveryGetStationConfigAllStationsConfigsQueryResponse, TQueryData = FragmentsDeliveryGetStationConfigAllStationsConfigsQueryResponse, TQueryKey extends QueryKey = FragmentsDeliveryGetStationConfigAllStationsConfigsQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<FragmentsDeliveryGetStationConfigAllStationsConfigsQueryResponse, ResponseErrorConfig<FragmentsDeliveryGetStationConfigAllStationsConfigs401 | FragmentsDeliveryGetStationConfigAllStationsConfigs403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? fragmentsDeliveryGetStationConfigAllStationsConfigsQueryKey()
         

         const query = useQuery({
          ...fragmentsDeliveryGetStationConfigAllStationsConfigsQueryOptions(config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FragmentsDeliveryGetStationConfigAllStationsConfigs401 | FragmentsDeliveryGetStationConfigAllStationsConfigs403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}